const Loading = () => {
  return (
    <svg className="animate-spin size-10" viewBox="0 0 24 24">
      {/* <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="2"
      ></circle> */}
      <circle
        className="text-green-500"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={2}
        cx="12"
        cy="12"
        r="10"
        strokeDasharray="30"
        strokeDashoffset="0"
      ></circle>
    </svg>
  );
};

export default Loading;
